import { createUseStyles } from "react-jss";

const useStyles = createUseStyles({
    sliderContainer: {
        display: "flex",
        overflow: "hidden",
        width: "100%",
        position: "relative",
    },
    sliderWrapper: {
        display: "flex",
        transition: "transform 1s ease-in-out",
    },
    slide: {
        minWidth: "100vw",
        boxSizing: "border-box",
    },
    controls: {
        position: "absolute",
        top: "50%",
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        transform: "translateY(-50%)",
    },
    button: {
        background: "rgba(0, 0, 0, 0.5)",
        color: "white",
        border: "none",
        padding: "10px",
        cursor: "pointer",
    },
     dotsContainer: {
        position: 'absolute',
        bottom: '20px',
        left: '50%',
        transform: 'translateX(-50%)',
        display: 'flex',
        gap: '10px',
        zIndex: 10
    },
    dot: {
        width: '12px',
        height: '12px',
        borderRadius: '50%',
        border: 'none',
        backgroundColor: 'rgba(255, 255, 255, 0.5)',
        cursor: 'pointer',
        transition: 'background-color 0.3s ease',
        outline: 'none',
        '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.8)'
        }
    },
    dotActive: {
        backgroundColor: '#fff !important'
    }
});

export default useStyles;